import React from "react";
import ReactPaginate from "react-paginate";

const Pagination = ({ handlePageClick, pageCount, currentPage }) => {
  if (pageCount <= 1) return null; // hide pagination if only one page

  return (
    <div className="flex justify-end my-6 mt-10">
      <ReactPaginate
        forcePage={currentPage}
        breakLabel="..."
        nextLabel={currentPage === pageCount - 1 ? null : "Next"}
        previousLabel={currentPage === 0 ? null : "Prev"}
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        pageCount={pageCount}
        pageLinkClassName="!no-underline !text-inherit w-full h-full flex items-center justify-center"
        renderOnZeroPageCount={null}
        containerClassName="flex items-center gap-2"
        pageClassName="w-8 h-8 flex items-center justify-center text-gray-500 hover:text-black transition duration-150 ease-in-out"
        activeClassName="!text-black font-medium"
        breakClassName="text-gray-400"
        previousClassName="text-gray-500  transition duration-150 ease-in-out"
        nextClassName="text-gray-500 hover:text-black transition duration-150 ease-in-out"
        previousLinkClassName="!no-underline !text-inherit"
        nextLinkClassName="!no-underline !text-inherit"
      />
    </div>
  );
};

export default Pagination;
